
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateItemGroupDtoFormGroup() {
return new FormGroup({
    parentId: new FormControl<number | undefined>(undefined),
    childId: new FormControl<number | undefined>(undefined),
    budgetPrice: new FormControl<number | undefined>(undefined),
})
;
}
      